import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface BaseUrlValues {
  baseUrl: string;
}

interface Props<T extends BaseUrlValues> {
  formik: FormikProps<T>;
  placeholder?: string;
}

export const FormikVendorApiBaseUrlField = <T extends BaseUrlValues>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <FormikTextField
      formik={props.formik}
      label={labelsMsg.baseUrl}
      name='baseUrl'
      placeholder={props.placeholder}
      type='text'
    />
  );
};
